import {
  getMarkupMediaIdentity,
  getMarkupPdfDocument,
} from "@dialogueconsulting/sked-preview";
import type {
  MarkupMedia,
  MarkupAccount,
} from "@dialogueconsulting/sked-preview";
import type { ColCollaborator, ColComment } from "../types";
import type { User } from "features/user";

/** The already-adapted social preview model, shared by form and sheet callers. */
export interface MarkupPreviewPost {
  caption?: string;
  username?: string;
  profilePicture?: string;
  image_url?: string;
  medias?: { collection?: PreviewMedia[] };
  providedPost?: PreviewMedia;
}
interface PreviewMedia {
  id?: string;
  asset_id?: string;
  hash?: string;
  media_id?: string;
  urn?: string;
  url?: string;
  sourceUrl?: string;
  thumbnailUrl?: string;
  isVideo?: boolean;
  width?: number;
  height?: number;
  type?: string;
  pages?: number;
  originalUrl?: string;
  isDocument?: boolean;
  meta?: {
    width?: number;
    height?: number;
    pages?: number;
    mime?: string;
    isDocument?: boolean;
  };
}
export interface MarkupPostSnapshot {
  caption: string;
  media: MarkupMedia[];
  account: MarkupAccount;
}
export function markupPostSnapshot(
  post: MarkupPreviewPost | null | undefined
): MarkupPostSnapshot {
  const collection = post?.medias?.collection;
  const media = collection?.length
    ? collection
    : post?.providedPost && (post.image_url || post.providedPost.url)
      ? [{ ...post.providedPost, url: post.image_url || post.providedPost.url }]
      : [];
  return {
    caption: post?.caption || "",
    account: { name: post?.username || "", pictureUrl: post?.profilePicture },
    media: media.flatMap((item) => {
      const id =
        item.id ||
        item.asset_id ||
        item.hash ||
        item.media_id ||
        item.urn ||
        getMarkupMediaIdentity(item.sourceUrl || item.url || item.thumbnailUrl);
      if (!id) return [];
      return [
        {
          id,
          url: item.url,
          thumbnailUrl: item.thumbnailUrl,
          isVideo: item.isVideo,
          document: getMarkupPdfDocument(item),
          width: item.width || item.meta?.width,
          height: item.height || item.meta?.height,
        },
      ];
    }),
  };
}
export function markupReviewerName(
  comment: ColComment,
  collaborators: ColCollaborator[],
  user: User
) {
  if (comment.metadata?.username) return comment.metadata.username;
  if (comment.createdBy === user.userId)
    return (
      [user.firstName, user.lastName].filter(Boolean).join(" ") || user.userName
    );
  const author = collaborators.find((item) => item._id === comment.createdBy);
  return (
    [author?.firstName, author?.lastName].filter(Boolean).join(" ") ||
    author?.username ||
    "Unknown user"
  );
}
export function chronologicalMarkupComments(comments: ColComment[]) {
  return comments
    .filter(
      (comment) =>
        comment.type !== "DELETED" && comment.metadata?.markup?.version === 1
    )
    .sort(
      (a, b) =>
        (Date.parse(a.createdAt || "") || 0) -
        (Date.parse(b.createdAt || "") || 0)
    );
}
